import React from 'react';
import styled from 'styled-components';

import ButtonBase from '../ButtonBase';
import IconButtonBase from '../IconButton';
import SendIcon from '../Icons/Send';

const SendButton = React.forwardRef(
  ({ variant, label, icon, color, hoverBackground, background, borderRadius, ...props }, ref) => {
    if (variant === 'button') {
      return (
        <Button
          borderRadius={borderRadius}
          background={background}
          hoverBackground={hoverBackground}
          color={color}
          {...props}
          ref={ref}
        >
          {label}
        </Button>
      );
    }

    return (
      <IconButton
        textColor={color}
        borderRadius={borderRadius}
        hoverBackground={hoverBackground}
        {...props}
        ref={ref}
      >
        {(() => {
          if (!icon) {
            return null;
          }

          if (icon.url) {
            return <CustomIcon size={icon.size} url={icon.url} />;
          }

          return <SendIcon width={icon.size} height={icon.size} fill={icon.color} />;
        })()}
      </IconButton>
    );
  }
);

SendButton.displayName = 'SendButton';

const Button = styled(ButtonBase)`
  padding: 8px 10px;
  border: 1px solid ${props => props.color};
  border-radius: ${props => props.borderRadius};
  background: ${props => props.background};
  color: ${props => props.color};

  &:hover {
    background: ${props => props.hoverBackground};
  }
`;

const IconButton = styled(IconButtonBase)`
  padding: 0.5em;
  border-radius: ${props => props.borderRadius};

  &:hover {
    background: ${props => props.hoverBackground};
  }

  & svg {
    fill: ${props => props.textColor};
  }
`;

/**
 * @todo create custom icon component
 */
const CustomIcon = styled.i`
  width: ${props => `${props.size}px`};
  height: ${props => `${props.size}px`};
  background-image: ${props => `url(${props.url})`};
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
`;

export default SendButton;
